import { Duration } from "luxon";

/**
 * How long an `active` assignment record is trusted to still cover the present.
 *
 * An open record older than this is read as a missed logout: it covers the instants before its start plus this span
 * and nothing after. An event attributed to nobody beats one attributed to a driver who has left the unit.
 */
export const ASSIGNMENT_STALE_AFTER = Duration.fromObject({ days: 7 });
